import { _ } from '_locales';

const cleanHtml = (html) => (typeof html === 'string') && html
  .replace(/&#160;/g, ' ')
  .replace(/&#8217;/g, '’')
  .replace(/&#8203;/g, '')
  .replace(/&#13;/g, '')
  .replace(/&#8211;/g, '–')
  .replace(/&amp;/g, '&')
  .replace(/#/g, '')
  .replace(/&num;/g, '')
  .replace('<br />', '<br/>')
  .replace(/<br><\/br>/g, '<br/>')
  .replace(/\t/g, ' ')
  .replace(/<p><\/p>/g, '')
  .replace(/>\r?\n</g, '><')
  .replace(/\r?\n/g, '<br/>');

export const mumQuizReducer = (quizData, lessons) => quizData.map(({
  mat_nm: title,
  correct_disposal_option: correctOption,
  options,
  mat_id
}, i) => ({
  id: mat_id,
  oidx: i,
  answered: false,
  image: '',
  question: _('education.where_does_this_go'),
  // question: 'aaaa',
  wrongAnswerFeedback: cleanHtml(lessons[mat_id].body),
  correctAnswerFeedback: '',
  options: options.map(({
    disposal_nm: label,
    disposal_id
  }) => ({
    label: cleanHtml(label),
    id: disposal_id,
    value: disposal_id,
    selected: false,
    nuetral: true
  })),
  title,
  correctOption,
}));

export const rfQuizReducer = (quizData, lessons) => {
  const quiz = quizData.map(({
    campaign_id,
    campaign_coachable_id,
    correct_answer_feedback: correctAnswerFeedback,
    wrong_answer_feedback: wrongAnswerFeedback,
    image_path: image,
    quiz_correct_answer: correctOption,
    poll_quiz_question: question,
    ...options
  }, i) => ({
    id: campaign_coachable_id,
    activityId: campaign_id,
    correctAnswerFeedback: cleanHtml(correctAnswerFeedback),
    wrongAnswerFeedback: cleanHtml(wrongAnswerFeedback),
    oidx: i,
    answered: false,
    question: cleanHtml(question),
    title: lessons[campaign_id].title,
    options: Object
      .keys(options)
      .filter((opt) => options[opt])
      .map((opt) => ({
        label: cleanHtml(options[opt]),
        id: Number(opt.substr(17)),
        value: Number(opt.substr(17)),
        selected: false,
        nuetral: true
      })),
    image,
    correctOption
  }));
  return quiz;
};

export const misundestoodMaterialsReducer = (materials) => materials.reduce((prev, {
  mat_id: id,
  mat_img: image,
  mat_nm: materialName,
  mat_cat_header: header,
  mat_cat_description: body
}, i) => {
  const newObj = prev;
  newObj[id] = newObj.id || id;
  newObj[id] = {
    id,
    image,
    materialName,
    header,
    body: cleanHtml(body),
    title: materialName,
    oidx: i,
    done: false,
    isLastItem: i === materials.length - 1,
  };
  return newObj;
}, {});

export const recyclingFundamentalsReducer = (lessons) => lessons
  .reduce((prev, {
    campaign_id,
    campaign_coachable_id,
    activities,
    title
  }, i) => {
    const newObj = prev;
    newObj[campaign_id] = newObj.id || campaign_id;
    newObj[campaign_id] = {
      id: campaign_id,
      activityId: campaign_coachable_id,
      oidx: i,
      title,
      activity: activities[0],
      done: false,
      progress: {},
      isLastItem: i === lessons.length - 1,
    };
    return newObj;
  }, {});
